module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_3009.10009b69.png";